<template>
    <div>
      <h2>{{ msg }} </h2>
    </div>
</template>

<script>
import oidcOAuth from '@/models/BimPlus';
import userManager from '@/auth0/oidc-client.js';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { useRoute, useRouter } from 'vue-router';
import { reactive, onMounted, toRefs } from 'vue';

export default {
  name: 'BimPlusAuth',
  setup() {
    const store = useStore();
    const toast = useToast();
    const route = useRoute();
    const router = useRouter();

    const data = reactive({
      msg: 'Preparing...',
    });

    onMounted( async () => {
      try{   
        if (route.params.oauth === 'authorize') {
          await userManager.signinRedirect();
        } else if (route.params.oauth  === 'callback') {
          const auth = await oidcOAuth.setAccessToken(route.query);
          const urlforToken = route.fullPath.replace('bimplus/callback', '').slice(1);
          const userDetails = await userManager.signinCallback(urlforToken);
          if (userDetails !== null && userDetails.access_token !== '') {
            toast.success('Model view enabled');
            store.commit('setBimPlusDetails', userDetails);
            router.push({ name: 'projects' });
          } else {
            toast.error('Error on BIM Auth');
          }
        }
      } catch (e) {
        console.error(e);
        router.push({ name: 'account-general-settings' });
      }
    });

    return {
      ...toRefs(data)
    }
  },
};
</script>
